import {ProcessTaskDefinitionVersionNode} from 'graphql-client/__generated/graphqlGlobalTypes';
import * as net from 'util/Net';

import {ProcessTaskDefinitionGraphQL} from '../../../graphql-fragments/processes/__generated/ProcessTaskDefinitionGraphQL';
import {CreateProcessTaskSchemaRequest, TaskSchemaSpec} from './ProcessSchemaDAO';

type CreateProcessTaskDefinitionVersionSpec = {
  applicationData: any; // oxlint-disable-line @typescript-eslint/no-explicit-any
} & (
  | {
      taskSchemaId: string;
    }
  | {
      taskSchemaSpec: CreateProcessTaskSchemaRequest;
    }
);

export interface CreateProcessTaskDefinitionRequest {
  name: string;
  organizationId: string;
  firstVersion: CreateProcessTaskDefinitionVersionSpec;
}

export function createProcessTaskDefinition(
  data: CreateProcessTaskDefinitionRequest
): Promise<ProcessTaskDefinitionGraphQL> {
  return net.postJSONPromise({
    url: '/1/api/process-task-definitions',
    data,
  });
}

export function updateProcessTaskSchemaWithTaskDefinitionVersion(
  params: {
    processTaskDefinitionId: string;
  } & TaskSchemaSpec
): Promise<ProcessTaskDefinitionVersionNode> {
  const {processTaskDefinitionId, ...taskSchemaSpec} = params;

  return net.postJSONPromise({
    url: `/1/api/process-task-definition-versions/${processTaskDefinitionId}:update-task-schema`,
    data: taskSchemaSpec,
  });
}
